import styled from 'styled-components';

type Props = {
  isDisabled: boolean;
};

const Wrapper = styled.div<Props>`
  width: fit-content;
  min-width: 120px;
  height: 44px;
  display: flex;
  background: ${(props) => props.theme.colors.widget_background};
  border-radius: 6px;
  opacity: ${(props) => props.isDisabled && '0.5'};
  cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};

  .entity-preview {
    display: flex;
    align-items: center;
    gap: 0;
    width: 100%;
    cursor: ${(props) => (props.isDisabled ? 'default' : 'pointer')};

    .avatar {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 44px;
      height: 44px;
      background: #6B6B6B;
      border-radius: 6px 0 0 6px;
      flex-shrink: 0;

      img {
        width: 24px;
        height: 24px;
        object-fit: cover;
      }
    }

    .description {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      flex: 1;
      min-width: 0;
      padding: 0 12px 0 8px;

      .title {
        font-size: 16px;
        padding-bottom: 4px;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }

      .subtitle {
        font-size: 13px;
        color: ${(props) => props.theme.colors.inactive};
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
`;

export default { Wrapper };
